// import { RingLoader } from 'react-spinners';
import { BowtieLoader } from '../../atoms';

export * from 'react-spinners';
export const DefaultLoader = BowtieLoader;
